export default "__VITE_ASSET__B6o4X45L__"